import { StyleSheet } from 'react-native';

import { withOpacity } from '@/styles/styles';

import { Text } from './TextComponent';
import { Box } from './lib/components';
import { ds } from './lib/design.system';

const styles = StyleSheet.create({
    icon: {
        backgroundColor: withOpacity(ds.colorValue.background.brand.emphasis, 0.2),
    },
});

export const SgpIcon = ({ isSgpPlus = false }: { isSgpPlus?: boolean }) => {
    return (
        <Box
            style={styles.icon}
            justifyContent="center"
            alignItems="center"
            borderWidth={1}
            borderColor={ds.colorToken.background.brand.emphasis}
            borderRadius="r6"
            height={20}
            paddingHorizontal="s4"
        >
            <Text variant="labelSmall" color={ds.colorToken.text.brand}>
                {`SGP${isSgpPlus ? '+' : ''}`}
            </Text>
        </Box>
    );
};
